<div class="container">
  <h2 class="mat-headline-3">{{ 'WM_TECH.LANDING.CHOOSE_PLAN' | translate }}</h2>

  <div class="wrapper">
    <div class="plans">
      <ng-container *ngIf="plans.length; else plansLoading">
        <div *ngFor="let plan of plans; let i = index" class="plans-items align-center" [ngClass]="{ 'plans-items--first': i === 0, 'plans-items--last': plan.custom }">
          <div class="plans-items__head mat-h2">
            <p *ngIf="!plan.custom" class="plans-items__count">{{ 'WM_TECH_MMS.PRICES.UP_TO' | translate }} {{ plan.maxCount }}</p>
            <p *ngIf="plan.custom" class="plans-items__count">{{ 'WM_TECH_MMS.PRICES.FROM' | translate }} {{ plan.maxCount }}</p>
            <p class="plans-items__workers">{{ 'WM_TECH_MMS.PRICES.WORKERS' | translate }}</p>
          </div>

          <ng-container *ngIf="!plan.custom; else lastTemplate">
            <div class="plans-items__main">
              <p class="plans-items__price mat-headline-1">{{ plan.price }}</p>
              <p class="plans-items__coin mat-small" *ngIf="!plan.custom">USDT</p>
            </div>
            <p class="plans-items__period" *ngIf="!plan.custom">{{ 'WM_TECH_MMS.PRICES.MONTHLY_PER_WORKER' | translate }}</p>
          </ng-container>

          <ng-template #lastTemplate>
            <p class="plans-items__contact mat-headline-4 bold uppercase" *ngIf="plan.custom">{{ 'WM_TECH_MMS.PRICES.CONTACT_US' | translate }}</p>
          </ng-template>

          <div class="plans-items__ribbon">
            <svg width="91" height="91" viewBox="0 0 91 91" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M29.187 8V0.000976562L1.14441e-05 0.000976563V8L29.187 8Z" fill="#111414" />
              <path d="M90.813 90.803V61.615H82.0005V90.803H90.813Z" fill="#111414" />
              <path
                d="M0 0.000976563L90.8 90.801L90.812 90.7889V58.5549C90.8119 56.8022 90.1155 55.1213 88.876 53.882L36.93 1.93604C36.3164 1.32227 35.5879 0.835356 34.7861 0.503174C33.9843 0.170992 33.1249 1.61749e-05 32.257 0L0 0.000976563Z"
                fill="#3D3D3D"
              />
            </svg>
            <span>{{ 'WM_TECH_MMS.PRICES.PLAN_NAME.' + plan.name | uppercase | translate }}</span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <button mat-raised-button color="tech-button-bg-primary prices__contact_us" type="submit" class="submit-button" [routerLink]="['/support']" routerLinkActive="router-link-active">
    {{ 'WM_TECH_MMS.PRICES.CONTACT_US' | translate }}
  </button>

  <app-partners></app-partners>
</div>

<ng-template #plansLoading>
  <div class="plans-items wm-loading" style="height: 260px; width: 200px"></div>
  <div class="plans-items wm-loading" style="height: 235px; width: 200px"></div>
  <div class="plans-items wm-loading" style="height: 235px; width: 200px"></div>
  <div class="plans-items wm-loading" style="height: 235px; width: 200px"></div>
</ng-template>
